import React, { Suspense, lazy, useEffect, useState } from 'react';
import { isOffline } from '../../utils/network';

// The band itself is a lazy chunk; utils/swRegister.js warms it when the
// browser is idle so it is already saved (HTTP / service-worker cache) by
// the time the connection drops.
export const loadOfflineIndicator = () => import('./OfflineIndicator');
const OfflineIndicator = lazy(loadOfflineIndicator);

/** Renders the connection band from the first time the browser goes offline. */
const NetworkStatusGate = () => {
  const [needed, setNeeded] = useState(isOffline);
  useEffect(() => {
    if (needed) return undefined;
    const show = () => setNeeded(true);
    window.addEventListener('offline', show);
    return () => window.removeEventListener('offline', show);
  }, [needed]);
  if (!needed) return null;
  return <Suspense fallback={null}><OfflineIndicator /></Suspense>;
};

export default NetworkStatusGate;
